/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React from "react";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";
// Material UI components
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import CircularProgress from "@mui/material/CircularProgress";
// Custom components
import ProjectListingHeader from "./components/ProjectListingHeader";
import ChildListingHeader from "../../../shared-components/crud/listing/ChildListingHeader";
import FullPersonnelListItem from "../../../shared-components/FullPersonnelListItem";
import InstanceList from "../../../shared-components/crud/listing/InstanceList";
import StatusCard from "../../../shared-components/cards/StatusCard";
import POCCard from "../../../shared-components/cards/POCCard";
import ProjectStatusSteps from "../instance/ProjectStatusSteps";

const container = {
	show: {
		transition: {
			staggerChildren: 0.04
		}
	}
};
const item = {
	hidden: { opacity: 0, y: 20 },
	show: { opacity: 1, y: 0 }
};

function ProjectListingItem(props) {
  const { project } = props;
  const [loading, setLoading] = useState(true);
  // if the project exists, set loading to false
  useEffect(() => {
    if (project) {
      setLoading(false);
    }
  }, [])

  // ensure data exists
  if (!project || loading) {
    return (
      <CircularProgress />
    )
  }

  return (
    <div>
      <ProjectListingHeader title={project.title} logo="dli" project_id={project.id} />
      <Divider />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div className="flex flex-col px-32 py-16">
            <ChildListingHeader resource="courses" parent={project.id} />
            <Divider className="mt-16 mb-32" />
            <InstanceList listing={project.courses} resource="courses" />
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-32 w-full px-32 py-16 max-h-full">
            <motion.div
              className="col-span-1 flex flex-col flex-auto space-y-16"
              variants={item}              
            >
              <StatusCard instance={project} steps={ProjectStatusSteps} resource="Project" />
            </motion.div>
            <motion.div
              className="col-span-1 flex flex-col flex-auto space-y-16"
              variants={item}              
            >
              <POCCard instance={project} />
            </motion.div>
          </div>
        </Grid>
      </Grid>          
    </div>
  );
}

export default ProjectListingItem;
